import React from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const gradientClass =
  "bg-gradient-to-b from-[#484139] via-[#544C44] via-[#5D554C] via-[#655E54] to-[#6B5B4F]";

const categories = [
  { name: "Hair Care", icon: "/HairCareIcon.png" },
  { name: "Body Care", icon: "/BodyCareIcon.png" },
  { name: "Facial Care", icon: "/FacialCareIcon.png" },
  { name: "Sun Protection", icon: "/SunProtectionIcon.png" },
];

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className={`${gradientClass} min-h-screen`}>
      {/* Hero */}
      <section className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center">
          {/* Text */}
          <div className="text-[#E3D5C5] space-y-5 sm:space-y-7 max-w-xl mx-auto lg:mx-0 text-center lg:text-left">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold leading-tight">
              Glow Beyond
              <br className="hidden sm:block" /> Limits
            </h1>
            <p className="text-base sm:text-lg lg:text-xl text-[#E3D5C5]/90 leading-relaxed">
              Transform your skincare routine with our innovative solutions, crafted to
              bring out your natural beauty and deliver a luminous, healthy glow.
            </p>
            <button
              onClick={() => navigate("/products")}
              className="inline-flex items-center gap-2 bg-[#DDBB92] text-[#2B2A29] px-6 sm:px-8 py-3 sm:py-4 rounded-full font-serif font-semibold text-base sm:text-lg hover:opacity-90 transition mx-auto lg:mx-0"
            >
              <span>Explore more</span>
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>

          {/* Hero Image */}
          <div className="flex justify-center order-first lg:order-last">
            <img
              src="/Hero.png"
              alt="Skincare hero"
              className="w-full max-w-md lg:max-w-full h-auto object-contain"
            />
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="container mx-auto px-4 sm:px-6 lg:px-8 pb-12 sm:pb-16 lg:pb-20">
        <h2 className="text-center text-[#E3D5C5] font-serif text-2xl sm:text-3xl lg:text-4xl font-bold mb-6 sm:mb-10">
          Shop by Category
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {categories.map((cat) => (
            <button
              key={cat.name}
              onClick={() => navigate("/products")}
              className="bg-[#484139] rounded-2xl p-4 sm:p-5 shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all cursor-pointer text-left"
            >
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-14 h-14 sm:w-16 sm:h-16 lg:w-20 lg:h-20 bg-purple-100 rounded-xl flex items-center justify-center flex-shrink-0 overflow-hidden">
                  <img
                    src={cat.icon}
                    alt={cat.name}
                    className="w-full h-full object-contain p-1"
                  />
                </div>
                <span className="font-serif font-semibold text-[#E3D5C5] text-sm sm:text-base lg:text-lg">
                  {cat.name}
                </span>
              </div>
            </button>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Home;
